<template>
  <base-card dark :to="to">
    <v-img
      class="grey lighten-2 img-card"
      :height="height"
      :aspect-ratio="aspectRatio"
      :class="{'is-mobile': $vuetify.breakpoint.xsOnly}"
      :src="src"
    >
      <v-layout fill-height align-center>
        <v-flex xs12>
          <div class="text-xs-center">
            <h1 class="font-weight-bold shadow mb-2" :class="headingSize">{{ title }}</h1>
            <tk-btn light outline color="white">
              <span class="font-weight-medium">{{ $t('ARTWORK.VIEW_ALL') }}</span>
            </tk-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-img>
  </base-card>
</template>

<script>
export default {
  props: ["height", "src", "title", "to", "titleI18n", "aspectRatio"],

  computed: {
    headingSize() {
      if (this.$vuetify.breakpoint.md) return "headline";
      if (this.$vuetify.breakpoint.smAndDown) return "title";
      return "display-1";
    },
  },
};
</script>

<style lang="scss">
.img-card {
  .layout {
    margin-top: 0px !important;
  }

  .v-btn {
    border-radius: 0px;
    border-width: 1px;
    font-size: 0.8rem;
    min-width: 160px;
  }

  h2 {
    color: #fff;
  }

  &:hover {
    .v-btn {
      background-color: #000 !important;
      border-color: #000 !important;
      color: #fff !important;
    }
  }

  &.is-mobile {
    .v-btn {
      background-color: #fff !important;
      color: #000 !important;
      border-color: #fff !important;
      font-size: 0.8rem !important;
      padding: 6px;
      height: auto;
      min-width: 8rem;
    }
  }
}
</style>